import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import type { Template, TemplateStore } from '@/types';
import api from '@/lib/api';

export const useTemplateStore = create<TemplateStore>()(
  devtools(
    (set) => ({
      templates: [],
      loading: false,
      error: null,

      fetchTemplates: async (params) => {
        set({ loading: true, error: null });
        try {
          const templates = await api.getTemplates(params);
          set({ templates, loading: false });
        } catch (error) {
          set({
            error: error instanceof Error ? error.message : 'Failed to fetch templates',
            loading: false,
          });
        }
      },

      createTemplate: async (data: Partial<Template>) => {
        set({ loading: true, error: null });
        try {
          const template = await api.createTemplate(data);
          set((state) => ({
            templates: [...state.templates, template],
            loading: false,
          }));
          return template;
        } catch (error) {
          set({
            error: error instanceof Error ? error.message : 'Failed to create template',
            loading: false,
          });
          throw error;
        }
      },

      applyTemplate: async (templateId: string, quoteId: string) => {
        set({ loading: true, error: null });
        try {
          await api.applyTemplate(templateId, quoteId);
          set({ loading: false });
        } catch (error) {
          set({
            error: error instanceof Error ? error.message : 'Failed to apply template',
            loading: false,
          });
          throw error;
        }
      },
    }),
    { name: 'TemplateStore' }
  )
);
